import {Component, Input} from '@angular/core';
import {ContractTerm, ProductOffering, UpgradeProtectionType} from '@uofu-uss-aux/software-catalog-ng-core';
import {LicensingService} from '../licensing.service';
import {CalendarIconComponent} from '../../svg/calendar-icon/calendar-icon.component';
import {DatePipe, NgIf} from '@angular/common';
import {CheckCircleFillIconComponent} from '../../svg/check-circle-fill-icon/check-circle-fill-icon.component';

@Component({
  selector: 'app-license-info',
  templateUrl: './license-info.component.html',
  styleUrls: ['./license-info.component.scss'],
  standalone: true,
  imports: [
    CalendarIconComponent,
    DatePipe,
    NgIf,
    CheckCircleFillIconComponent
  ]
})
export class LicenseInfoComponent {

  hasPerpetualLicense: boolean;
  hasItemsWithoutUpgradeProtection: boolean;
  hasItemsWithUpgradeProtection: boolean;
  hasItemsWithUpgradeProtectionOnly: boolean;
  earliestEndDate: Date;

  constructor(private readonly licensingService: LicensingService) {
  }

  @Input()
  set offerings(offers: ReadonlyArray<ProductOffering>) {
    this.hasPerpetualLicense = false;
    this.hasItemsWithoutUpgradeProtection = false;
    this.hasItemsWithUpgradeProtection = false;
    this.hasItemsWithUpgradeProtectionOnly = false;
    this.earliestEndDate = null;
    this.initializeWithOffers(offers || []);
  }

  private initializeWithOffers(offers: ReadonlyArray<ProductOffering>) {
    offers.forEach(offer => {
      this.hasPerpetualLicense = this.hasPerpetualLicense || offer.contractTerm === ContractTerm.PerpetualLicense;
      this.hasItemsWithoutUpgradeProtection = this.hasItemsWithoutUpgradeProtection
          || offer.upgradeProtectionType !== UpgradeProtectionType.Included;
      this.hasItemsWithUpgradeProtection = this.hasItemsWithUpgradeProtection
          || offer.upgradeProtectionType === UpgradeProtectionType.Included;
      this.hasItemsWithUpgradeProtectionOnly = this.hasItemsWithUpgradeProtectionOnly ||
          offer.upgradeProtectionType === UpgradeProtectionType.UpgradeProtectionOnly;
    });
    this.earliestEndDate = this.licensingService.pickEarliestEndDate(offers);
  }

  get hasNoUpgradeProtection(): boolean {
    return !this.hasItemsWithUpgradeProtectionOnly && !this.hasItemsWithUpgradeProtection;
  }

  get licenseInfoNeeded(): boolean {
    return this.hasItemsWithUpgradeProtection ||
        this.hasItemsWithUpgradeProtectionOnly ||
        !!this.earliestEndDate ||
        this.hasPerpetualLicense;
  }

}
